// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-portal-footer{z-index:var(--z-index-portal-footer);position:fixed;right:0;bottom:0;left:0;max-width:1920px;margin-left:auto;margin-right:auto}", ""]);
// Exports
module.exports = exports;
